module.exports = __webpack_public_path__ + "img/ceramic-woah.3e11d12d.jpg";